// extracted by mini-css-extract-plugin
export default {"window":"booking_window__wO3S9","bookingForm":"booking_bookingForm__SspPX","inputSelect":"booking_inputSelect__TytfZ"};